import React from 'react';
import PopupComponent from '../../components/PopupComponent';
import ReportsGrid from './ReportsGrid';

interface ReportSelectorPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onReportSelect: (reportId: string, reportTitle: string) => void;
}

const ReportSelectorPopup: React.FC<ReportSelectorPopupProps> = ({
  isOpen,
  onClose,
  onReportSelect
}) => {
  return (
    <PopupComponent
      isOpen={isOpen}
      onClose={onClose}
      title="Select Report"
      size="lg"
    >
      <div style={{
        maxHeight: '70vh',
        overflowY: 'auto',
        padding: '8px 0'
      }}>
        <ReportsGrid onReportSelect={onReportSelect} />
      </div>
    </PopupComponent>
  );
};

export default ReportSelectorPopup;